import { Flex } from '@theme-ui/components';
import type { SerializedStyles } from '@emotion/react';
import { css } from '@emotion/react';

import ErrorBoundary from '@app/components/ErrorBoundary';
import theme from '@app/styles/theme';

import Footer from '../../components/Footer';
import Header from '../../components/Header';

const wrapper: SerializedStyles = css`
  background-color: ${theme.colors.white};
  flex: 1;
`;

const PricingLayout = ({ children }: { children: React.ReactNode }) => (
  <Flex sx={{ flexDirection: 'column', height: '100vh' }}>
    <div css={wrapper}>
      <Header subMenu={true} />
      <ErrorBoundary>{children}</ErrorBoundary>
    </div>
    <Footer />
  </Flex>
);

export default PricingLayout;
